import React, { useEffect, useRef, useState } from "react";
import Modal from "rsuite/Modal";
import Loader from "rsuite/Loader";
import MeetingCalendarView from "./MeetingCalendarView";
import { useMeetingList } from "../../../../reducers/meetingList";

const ScheduleMeetingModal = ({ showModal, closeModal, customerDetails }) => {
  const { status, authUrl, currentUser, fetchMeetings } = useMeetingList();
  const [isAuthorizing, setIsAuthorizing] = useState(false);
  const useremail = useRef();

  useEffect(() => {
    if (currentUser.email) {
      useremail.current = currentUser.email;
    }
  }, [currentUser]);

  useEffect(() => {
    const handleMessage = (event) => {
      if (
        event &&
        event.data &&
        event.data.type === "GMAIL_INTEGRATION_SUCCESS"
      ) {
        fetchMeetings(useremail.current);
        setIsAuthorizing(false);
      }
    };

    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, [fetchMeetings]);

  const handleAuthorize = () => {
    if (authUrl) {
      setIsAuthorizing(true);
      window.open(authUrl, "_blank");
    }
    // closeModal(); // Removed to keep modal open
  };

  return (
    <Modal
      open={showModal}
      onClose={closeModal}
      size={status === "authorized" ? "lg" : "sm"}
      id="edit"
      style={{ zIndex: 9999 }}
      className="meetingMain"
    >
      <Modal.Header>
        <div className="modal-title">Schedule Meeting</div>
      </Modal.Header>

      <Modal.Body>
        {/* ── Loading ── */}
        {status === "loading" && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: "120px",
            }}
          >
            <Loader size="md" content="Loading meetings…" />
          </div>
        )}

        {/* ── Authorized – calendar view ── */}
        {status === "authorized" && (
          <MeetingCalendarView
            currentUser={currentUser}
            customerDetails={customerDetails}
          />
        )}

        {/* ── Reauth required ── */}
        {status === "reauth" && (
          <div
            style={{
              minHeight: "160px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              gap: "16px",
              textAlign: "center",
              padding: "16px",
            }}
          >
            {/* Google calendar style icon */}
            <svg
              width="48"
              height="48"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="3"
                y="4"
                width="18"
                height="17"
                rx="2"
                stroke="#EA4335"
                strokeWidth="2.5"
              />
              <path
                d="M3 9H21"
                stroke="#EA4335"
                strokeWidth="2.5"
                strokeLinecap="round"
              />
              <path
                d="M8 2V6M16 2V6"
                stroke="#EA4335"
                strokeWidth="2.5"
                strokeLinecap="round"
              />
              <path
                d="M12 13V17M12 17L10 15M12 17L14 15"
                stroke="#EA4335"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <div>
              <p
                style={{
                  margin: "0 0 6px",
                  fontSize: "15px",
                  fontWeight: 600,
                  color: "#333",
                }}
              >
                Google Authorization Required
              </p>
              <p style={{ margin: 0, fontSize: "13px", color: "#666" }}>
                This feature allows the CRM application to read your calender
                and schedule meetings. <br></br> This feature is intended for
                customer-facing employees only. <br></br> You will be redirected
                to Gmail to authorize access.
              </p>
            </div>
          </div>
        )}
      </Modal.Body>

      <Modal.Footer>
        {status === "reauth" && (
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: "10px",
            }}
          >
            <button
              onClick={closeModal}
              className="cancel-btn"
              style={{ marginBottom: "0 !important" }}
            >
              Cancel
            </button>
            <button
              onClick={handleAuthorize}
              className="btn-primary"
              style={{
                marginBottom: "0 !important",
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}
              disabled={isAuthorizing}
            >
              {isAuthorizing ? (
                <React.Fragment>
                  <Loader size="xs" /> Authorizing...
                </React.Fragment>
              ) : (
                "Authorize with Google"
              )}
            </button>
          </div>
        )}
        <style>
          {`
          .meetingMain .rs-modal-header {
    padding: 12px !important;
    border-bottom: 1px solid #dce1e9 !important;
}
   .meetingMain .rs-modal-body {
    padding: 12px !important;
    padding-top: 14px !important;
    margin: 0 !important;
}
    .meetingMain .rbc-events-container::-webkit-scrollbar{
            width: 10px;
        height: 6px;
        color: #555;
        background: transparent !important;
    }
       .meetingMain .rbc-events-container::-webkit-scrollbar-thumb {
        background: #888;
        border-radius: 5px;
    }
        ::-webkit-scrollbar-track {
    background: #f6f6f6;
}
    .meetingMain 
.modal-title {
    color: #333;
    font-family: Poppins;
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
}

        `}
        </style>
      </Modal.Footer>
    </Modal>
  );
};

export default ScheduleMeetingModal;



// WEBPACK FOOTER //
// ./src/components/crm/leads/components/ScheduleMeetingModal.js